import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { errorIcon } from '@ld.consumer-portal/data-uri';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface PaymentPortalCompleteData {
  confirmationNumber?: string;
  amount?: number;
  paymentDate?: Date;
}

@Component({
  selector: 'ld-payment-portal-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './payment-portal-modal.component.html',
  styleUrl: './payment-portal-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentPortalModalComponent {
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly errorIcon = errorIcon;

  readonly paymentUrl = input.required<string>();

  readonly complete = output<PaymentPortalCompleteData>();

  readonly cancel = output<void>();

  protected readonly isLoading = signal(true);

  protected readonly hasError = signal(false);

  protected readonly safeUrl = computed<SafeResourceUrl>(() => {
    const url = this.paymentUrl();
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  });

  protected onIframeLoad(): void {
    this.isLoading.set(false);
  }

  protected onIframeError(): void {
    this.isLoading.set(false);
    this.hasError.set(true);
  }

  protected onClose(): void {
    this.cancel.emit();
  }

  protected onDone(): void {
    this.complete.emit({});
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.cancel.emit();
    }
  }
}
